import axios from "axios";
import {removeUserForgetPasswordErrors, setUserForgetPasswordError} from "./AuthErrorsActions";
import {forgetPasswordTypes} from "./AuthActionsTypes/ForgetPasswordActionsTypes";

export const requestUserForgetPassword = () => {
    return {
        type: forgetPasswordTypes.FORGET_PASSWORD_REQUEST,
    };
};

export const successUserForgetPassword = (data) => {
    return {
        type: forgetPasswordTypes.FORGET_PASSWORD_SUCCESS,
    };
};

export const failureUserForgetPassword = (data) => {
    return {
        type: forgetPasswordTypes.FORGET_PASSWORD_FAILURE,
    };
};

export const userForgetPassword = (user) => {
    return (dispatch, getState) => {
        dispatch(removeUserForgetPasswordErrors());
        dispatch(requestUserForgetPassword());

        // TODO: Replace with ..
        const USER_FORGET_PASSWORD_API = "https://api.scoutafrique.com/api/auth/password/forget";

        return axios.post(USER_FORGET_PASSWORD_API, user)
            .then(response => {
                const data = response.data;

                dispatch(successUserForgetPassword(data));
            }).catch(error => {

                dispatch(failureUserForgetPassword());
                dispatch(setUserForgetPasswordError(error));
            });
    };
};
